import React from "react";
import { IconBrandFacebook, IconBrandInstagram } from '@tabler/icons-react';


const ServicesHome = () => {
  return (
    <footer id="footer" className="footer">
      <div className="footer-wrapper">
        <div className="footer-links--section">
          <h4 className="footer-title">Sobre Nosotros</h4>
          <div class="footer-links">
            <p className="footer-link">Contacto</p>
            <p className="footer-link">Compart</p>
            <p className="footer-link">Vender</p>
            <p className="footer-link">Trabaja Con Nosotros</p>
          </div>
        </div>
        <div className="footer-social--section">
          <h4 className="footer-title">Síguenos</h4>
          <div className="footer-social">
            <IconBrandFacebook stroke={2} className="footer-link footer-link-social"/>
            <IconBrandInstagram stroke={2} className="footer-link footer-link-social"/>
          </div>
        </div>
      </div>
      <small className="footer-copyright">Territorio Grupo Consultor e Inmobiliario&copy; 2024</small>
    </footer>
  );
};

export default ServicesHome;
